import React, { Component } from 'react';
import * as Styles from './Styles';
import Pocket from './pocket/Pocket';
import {
	OCTopContent,
	OCBottomContent,
	OCExtendedContent,
	OCHeading,
} from './content/OC';
import { OPExtendedContent, OPHeading, OPTopContent } from './content/OP';
import {
	NNWBottomContent,
	NNWExtendedContent,
	NNWHeading,
	NNWTopContent,
} from './content/NNW';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../../../core/Store';
import * as FormManager from '../../../../reducers/ui/form';
import * as DictionariesRisksSelectors from '../../../../reducers/data/dictionaries/risks/selectors';

type State = {};

class SectionsComponent extends Component<PropsFromRedux, State> {
	state = {};

	render() {
		const OCRiskSelected = this.props.selectedRisksIds.some(
			(el) => el <= 6
		);
		const NNWRiskSelected = this.props.selectedRisksIds.some(
			(el) => el >= 8 && el <= 15
		);

		return (
			<Styles.Wrapper id="form-stage1-risks">
				<Pocket
					heading={<OCHeading />}
					extendedContent={<OCExtendedContent />}
					contentTop={
						<OCTopContent
							risks={this.props.risksOc}
							selectedRisksIds={this.props.selectedRisksIds}
						/>
					}
					contentBottom={
						OCRiskSelected ? (
							<OCBottomContent
								selectOCExtendedRisk={
									this.props.selectOCExtendedRisk
								}
							/>
						) : undefined
					}
					error={this.props.sectionsError}
				/>
				{OCRiskSelected && (
					<Pocket
						heading={<OPHeading />}
						extendedContent={<OPExtendedContent />}
						contentTop={
							<OPTopContent
								risks={this.props.risksKop}
								selectedRisksIds={this.props.selectedRisksIds}
							/>
						}
					/>
				)}
				<Pocket
					heading={<NNWHeading />}
					extendedContent={<NNWExtendedContent />}
					contentTop={
						<NNWTopContent
							selectedColumn=""
							risks={this.props.risksNnw}
							selectedRisksIds={this.props.selectedRisksIds}
						/>
					}
					contentBottom={
						NNWRiskSelected ? (
							<NNWBottomContent
								risks={this.props.risksNnwKlauzule}
								selectedRisksIds={this.props.selectedRisksIds}
							/>
						) : undefined
					}
					error={this.props.sectionsError}
				/>
			</Styles.Wrapper>
		);
	}
}

interface Own {}

const connector = connect(
	(state: AppState, own: Own) => ({
		selectedRisksIds: FormManager.Selectors.getSelectedRisksIds(state),
		risksOc: DictionariesRisksSelectors.getRisksOc(state),
		selectOCExtendedRisk:
			FormManager.Selectors.getExtendedOcCoverageSelected(state),
		risksKop: DictionariesRisksSelectors.getRisksKop(state),
		risksNnw: DictionariesRisksSelectors.getRisksNnw(state),
		risksNnwKlauzule: DictionariesRisksSelectors.getRisksNnwKlauzule(state),
		sectionsError: FormManager.Selectors.getSectionsError(state),
	}),
	(dispatch) => ({})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const Sections = connector(SectionsComponent);
export default Sections;
